<script setup>

    import { computed} from 'vue'

    const props = defineProps({
        modelValue: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            required: true
        },
        showNullOption: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: '—'
        },
        input_class: {
            type: String,
            default: 'bg-white text-stone-700'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: 'h-[34px]'
        }
    })

    const emit = defineEmits(['update:modelValue'])

    const modelProxy = computed({
        get: () => props.modelValue ?? '',
        set: (value) => emit('update:modelValue', value === '' ? null : value),
    })

</script>

<template>
    <select
        :id="props.id"
        v-model="modelProxy"
        :disabled="props.disabled"
        :class="[
            'relative w-full pl-2.5 pr-10 md:px-2.5 py-7 md:py-1.5 rounded-md text-base tracking-wider border border-stone-400 sm:text-sm shadow-sm focus:border-lifeworx-blue-600 focus:ring-lifeworx-blue-600 focus:ring-1 focus:outline-none',
            props.input_class,
            props.disabled ? 'cursor-default opacity-50' : 'cursor-pointer',
            props.showNullOption && !modelValue ? '!text-stone-400' : '',
            props.height,
        ]"
    >
        <option
            v-if="props.showNullOption"
            value=""
        >
            {{ props.placeholder }}
        </option>
        <option
            v-for="(option, index) in props.options"
            :key="option.value"
            :value="option.value"
        >
            {{ option.name }}
        </option>
    </select>

</template>
